"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _stitches = require("../../../stitches.config");

var _wizardsSlice = require("../../../store/wizardsSlice");

var _sharedStyles = require("../sharedStyles");

var _Tip = _interopRequireDefault(require("../tip/Tip"));

var StyledQuestion = (0, _stitches.styled)('div', {
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '300px',
  '@tablet': {
    maxWidth: '475px'
  }
});
var Title = (0, _stitches.styled)(_sharedStyles.Title, {
  textAlign: 'center'
});
var Subtitle = (0, _stitches.styled)(_sharedStyles.Subtitle, {
  textAlign: 'center'
});
var QuestionTitle = (0, _stitches.styled)('div', {
  fontWeight: '$semiBold',
  marginTop: '20px',
  marginBottom: '15px',
  wordBreak: 'break-word'
});
var Error = (0, _stitches.styled)('div', {
  color: '$error',
  fontSize: '$small',
  marginTop: '-17px'
});
var GenderChoiceContainer = (0, _stitches.styled)('div', {
  display: 'flex',
  width: '100%'
});
var GenderChoice = (0, _stitches.styled)('div', {
  backgroundColor: '$white',
  border: '2px solid $grey400',
  display: 'inline-block',
  flex: '1',
  marginBottom: '5px',
  marginTop: '5px',
  padding: '10px 15px',
  textAlign: 'center',
  '&:hover': {
    cursor: 'pointer'
  },
  '&:first-child': {
    borderBottomLeftRadius: '25px',
    borderRight: 0,
    borderTopLeftRadius: '25px'
  },
  '&:last-child': {
    borderBottomRightRadius: '25px',
    borderTopRightRadius: '25px'
  },
  variants: {
    selected: {
      true: {
        border: '2px solid $secondary',
        fontWeight: '$bold',
        '&:first-child': {
          borderRight: '2px solid $secondary',
          ' + div': {
            borderLeft: 0
          }
        }
      }
    }
  }
});
var SizeChoiceTitle = (0, _stitches.styled)('div', {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between'
});
var SizeChoiceContainer = (0, _stitches.styled)('div', {
  display: 'flex',
  flexWrap: 'wrap',
  width: '300px',
  '@tablet': {
    width: '475px' // we want to cap it at 6 per row ¯\_(ツ)_/¯

  }
});
var ButtonChoice = (0, _stitches.styled)('div', {
  backgroundColor: '$white',
  border: '2px solid $grey400',
  borderRadius: '25px',
  display: 'inline-block',
  marginBottom: '5px',
  marginRight: '10px',
  marginTop: '5px',
  padding: '10px 15px',
  textAlign: 'center',
  '&:hover': {
    cursor: 'pointer'
  },
  variants: {
    selected: {
      true: {
        border: '2px solid $secondary',
        fontWeight: '$bold'
      }
    }
  }
}); // This fixes the shifting off buttons when one is selected

var BoldButtonHiddenText = (0, _stitches.styled)('div', {
  fontWeight: '$bold',
  height: '0px',
  visibility: 'hidden'
});
var SizeChoice = (0, _stitches.styled)(ButtonChoice, {
  padding: '8px 0px',
  marginLeft: '2px',
  marginRight: '2px',
  width: '52px',
  '@tablet': {
    marginLeft: '5px',
    marginRight: '5px',
    width: '65px'
  }
});
var WidthChoice = (0, _stitches.styled)(ButtonChoice, {
  width: 'calc(100%/2 - 60px)',
  '@tablet': {
    width: 'calc(100%/3 - 60px)'
  }
});
var WidthChoiceContainer = (0, _stitches.styled)(GenderChoiceContainer, {
  flexWrap: 'wrap',
  justifyContent: 'center'
});
/**
 * Question used to ask a user for their gender, shoe size, and shoe width.
 */

var SizeWidthQuestion = function SizeWidthQuestion(_ref) {
  var errorPrefix = _ref.errorPrefix,
      errorSuffix = _ref.errorSuffix,
      genderQuestion = _ref.genderQuestion,
      id = _ref.id,
      sizeLimit = _ref.sizeLimit,
      sizeQuestion = _ref.sizeQuestion,
      subtitle = _ref.subtitle,
      tip = _ref.tip,
      title = _ref.title,
      widthQuestion = _ref.widthQuestion;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isError = _useState2[0],
      setError = _useState2[1];

  var selectedGenderChoice = genderQuestion.choices.filter(function (choice) {
    return choice.value === genderQuestion.answer;
  })[0];
  var sizeTitleSuffix = genderQuestion.answer ? "(".concat(selectedGenderChoice.text, ") ").concat(sizeQuestion.answers.slice().sort(function (first, second) {
    return first - second;
  }).join(', ')) : '';

  var handleSizeAnswerSelect = function handleSizeAnswerSelect(_ref2) {
    var choiceValue = _ref2.choiceValue,
        subQuestionId = _ref2.subQuestionId;

    // TODO: add analytics
    if (sizeQuestion.answers.length < sizeLimit || sizeQuestion.answers.includes(choiceValue)) {
      dispatch((0, _wizardsSlice.setAnswer)({
        answer: choiceValue,
        questionPath: "".concat(id, ".").concat(subQuestionId)
      }));
      setError(false);
    } else {
      setError(true);
    }
  };

  var sizeQuestionSort = sizeQuestion.choices.map(Number).sort(function (a, b) {
    return a - b;
  });

  var handleAnswerSelect = function handleAnswerSelect(_ref3) {
    var choiceValue = _ref3.choiceValue,
        subQuestionId = _ref3.subQuestionId;
    // TODO: add analytics
    dispatch((0, _wizardsSlice.setAnswer)({
      answer: choiceValue,
      questionPath: "".concat(id, ".").concat(subQuestionId)
    }));
  };

  var handleGenderAnswer = function handleGenderAnswer(value) {
    handleAnswerSelect({
      choiceValue: value,
      subQuestionId: 'genderQuestion'
    });
    setError(false);
    dispatch((0, _wizardsSlice.setSizeAndWidthChoices)({
      gender: value,
      questionId: id
    }));
  };

  var handleGenderKeyboardEvent = function handleGenderKeyboardEvent(choiceValue, event) {
    if (event.key === 'Enter') {
      handleGenderAnswer(choiceValue);
    }
  };

  var handleSizeAnswer = function handleSizeAnswer(value) {
    handleSizeAnswerSelect({
      choiceValue: value,
      subQuestionId: 'sizeQuestion'
    });
  };

  var handleSizeKeyboardEvent = function handleSizeKeyboardEvent(choiceValue, event) {
    if (event.code === 'Space') {
      handleSizeAnswer(choiceValue);
    }
  };

  var handleWidthAnswer = function handleWidthAnswer(value) {
    handleAnswerSelect({
      choiceValue: value,
      subQuestionId: 'widthQuestion'
    });
  };

  var handleWidthKeyboardEvent = function handleWidthKeyboardEvent(choiceValue, event) {
    if (event.key === 'Enter') {
      handleWidthAnswer(choiceValue);
    }
  };

  return /*#__PURE__*/_react.default.createElement(StyledQuestion, null, /*#__PURE__*/_react.default.createElement(Title, null, title), /*#__PURE__*/_react.default.createElement(Subtitle, null, subtitle), /*#__PURE__*/_react.default.createElement(GenderChoiceContainer, null, genderQuestion.choices.map(function (choice) {
    return /*#__PURE__*/_react.default.createElement(GenderChoice, {
      "aria-checked": choice.value === genderQuestion.answer,
      className: "gender-choice",
      key: choice.value,
      role: "radio",
      selected: choice.value === genderQuestion.answer,
      tabIndex: 0,
      onClick: function onClick() {
        handleGenderAnswer(choice.value);
      },
      onKeyDown: function onKeyDown(event) {
        handleGenderKeyboardEvent(choice.value, event);
      }
    }, choice.text);
  })), /*#__PURE__*/_react.default.createElement(SizeChoiceTitle, null, /*#__PURE__*/_react.default.createElement(QuestionTitle, null, "".concat(sizeQuestion.title, " ").concat(sizeTitleSuffix)), /*#__PURE__*/_react.default.createElement(_Tip.default, tip)), isError && /*#__PURE__*/_react.default.createElement(Error, null, "".concat(errorPrefix, " ").concat(sizeLimit, " ").concat(errorSuffix)), /*#__PURE__*/_react.default.createElement(SizeChoiceContainer, null, sizeQuestionSort.map(function (choice) {
    return /*#__PURE__*/_react.default.createElement(SizeChoice, {
      "aria-checked": sizeQuestion.answers.includes(choice),
      className: "size-choice",
      key: choice,
      role: "radio",
      selected: sizeQuestion.answers.includes(choice),
      tabIndex: 0,
      onClick: function onClick() {
        handleSizeAnswer(choice);
      },
      onKeyDown: function onKeyDown(event) {
        handleSizeKeyboardEvent(choice, event);
      }
    }, choice);
  })), /*#__PURE__*/_react.default.createElement(QuestionTitle, null, "".concat(widthQuestion.title, " ").concat(widthQuestion.answer)), /*#__PURE__*/_react.default.createElement(WidthChoiceContainer, null, widthQuestion.choices.map(function (choice) {
    return /*#__PURE__*/_react.default.createElement(WidthChoice, {
      "aria-checked": choice.value === widthQuestion.answer,
      className: "width-choice",
      key: choice.value,
      role: "radio",
      selected: choice.value === widthQuestion.answer,
      tabIndex: 0,
      onClick: function onClick() {
        handleWidthAnswer(choice.value);
      },
      onKeyDown: function onKeyDown(event) {
        handleWidthKeyboardEvent(choice.value, event);
      }
    }, choice.text, /*#__PURE__*/_react.default.createElement(BoldButtonHiddenText, null, choice.text));
  })));
};

SizeWidthQuestion.defaultProps = {
  subtitle: '',
  tip: {},
  title: ''
};
var _default = SizeWidthQuestion;
exports.default = _default;